import breakpoints from 'config/mediaBreakpoints';
import Button from 'deprecated/atoms/button';
import copy from './copy';
import MediaQuery from 'react-responsive';
import React from 'react';
import { Link } from 'react-router-dom';

const SessionExpired = () => (
  <div className="sessionExpiredContainer">
    <div className="loginContent sessionExpired">
      <p>{copy.get('sessionExpired.message')}</p>

      <MediaQuery minWidth={breakpoints.loginCardWidth}>
        <Link to="/login">{copy.get('sessionExpired.link')}</Link>
      </MediaQuery>

      <MediaQuery maxWidth={breakpoints.smallerThanLoginCardWidth}>
        <Link to="/login">
          <Button
            style={{ width: '100%' }}
            label={copy.get('sessionExpired.link')}
          />
        </Link>
      </MediaQuery>
    </div>
  </div>
);

export default SessionExpired;
